import { useEntitlement } from './useEntitlement';

/**
 * Whether the tenant may use the generic check-in/check-out flow (Decision 1).
 * Thin wrapper over the shared entitlement resolver; the literal env read stays
 * here so CRA inlines it. Do NOT hardcode `true` (no-interim-defaults rule).
 */
export function useCanUseCheckInCheckOut(): boolean {
    return useEntitlement(
        'checkInCheckOut',
        process.env.REACT_APP_FORCE_CHECKIN_ENTITLEMENT === 'true',
    );
}
